export default function getPrice(price = {}, priceType) {
    const { currency, discount, minPrice, minPriceDiscount, sellingPrice, wasPrice } = price;
    const finalPrice = price[priceType] ? price[priceType] : sellingPrice;
    const calculatedFinalPrice = calculatePrice(finalPrice);
    const finalPriceWithoutCurrencySymbol = Number(calculatedFinalPrice).toFixed(getDecimalPlaces(calculatedFinalPrice));

    return {
        currency,
        discountPercentage: calculatePrice(discount),
        originalPrice: calculatePrice(wasPrice),
        finalPrice: calculatedFinalPrice,
        finalPriceWithoutCurrencySymbol,
        minimumPrice: calculatePrice(minPrice),
        minPriceDiscount: calculatePrice(minPriceDiscount),
    };
}

function calculatePrice(priceObj) {
    if (!priceObj) return undefined;

    const { amount, divisor } = priceObj;
    return Number(amount) / Number(divisor);
}

function getDecimalPlaces(price) {
    return price % 1 === 0 ? 0 : 2;
}
